export const SUMMARY_DETAILS_DISPLAY_CONFIG = [
  {
    key: 'subtotal',
  },
  {
    key: 'shipping_credit',
  },
  {
    key: 'restocking_fee',
  },
  {
    key: 'recycling_fee',
  },
  {
    key: 'tax',
  },
  {
    key: 'shipping_fee',
    displayIfZero: true,
    useFreeLabel: true,
  },
  {
    key: 'express_upgrade_fee',
  },
  {
    key: 'handling_fee',
  },
  {
    key: 'credit_reversal_amount',
  },
  {
    key: 'estimated_refund',
    style: { fontWeight: 'bold' },
    displayIfZero: true,
    useFreeLabel: false,
  },
];

export const SIDEBAR_SHIPPING_METHOD_CONFIG = [
  {
    width: 100,
    placeholder: 'Name',
    type: 'text',
    key: 'customer_name',
    required: true,
  },
  {
    width: 100,
    placeholder: 'Company (Optional)',
    type: 'text',
    key: 'company',
    required: false,
  },
  {
    width: 100,
    placeholder: 'Street Address',
    type: 'text',
    key: 'street_1',
    required: true,
  },
  {
    width: 70,
    placeholder: 'Apt/Suite (Optional)',
    type: 'text',
    key: 'street_2',
    required: false,
  },
  {
    width: 30,
    placeholder: 'Zip Code',
    type: 'text',
    key: 'zip',
    required: true,
  },
  {
    width: 70,
    placeholder: 'City',
    type: 'text',
    key: 'city',
    required: true,
  },
  {
    width: 20,
    placeholder: 'State',
    type: 'select',
    key: 'state',
    required: true,
  },
];

export const ADDRESS_FORM_FIELDS_MAPPING = {
  name: {
    type: 'text',
    placeholder: 'Full Name',
    key: 'customer_name',
    languageKey: 'address_form.input.customer_name',
  },
  firstName: {
    type: 'text',
    placeholder: 'First Name',
    key: 'first_name',
    languageKey: 'address_form.input.first_name',
  },
  lastName: {
    type: 'text',
    placeholder: 'Last Name',
    key: 'last_name',
    languageKey: 'address_form.input.last_name',
  },
  company: {
    type: 'text',
    placeholder: 'Company Name',
    key: 'company_name',
    languageKey: 'address_form.input.company_name',
    required: false,
  },
  address1: {
    type: 'text',
    placeholder: 'Street Address',
    key: 'street_1',
    languageKey: 'address_form.input.address_line1',
  },
  address2: {
    type: 'text',
    placeholder: 'Address Line 2',
    key: 'street_2',
    languageKey: 'address_form.input.address_line2',
    required: false,
  },
  postalCode: {
    type: 'text',
    placeholder: 'ZIP Code',
    key: 'zip',
    languageKey: 'address_form.input.postal_code',
  },
  city: { type: 'text', placeholder: 'City', key: 'city', languageKey: 'address_form.input.city' },
  state: {
    type: 'select',
    placeholder: 'State',
    key: 'state',
    languageKey: 'address_form.input.province',
  },
  region: {
    type: 'select',
    placeholder: 'Region',
    key: 'state',
    languageKey: 'address_form.input.province',
  },
  country: {
    type: 'select',
    placeholder: 'Country',
    key: 'country',
    languageKey: 'address_form.input.country',
  },
};

export const FAQ_LAYOUTS = {
  local_pickup: {
    title: 'returns.faq.local_pickup.title',
    sections: [
      {
        title: 'returns.faq.local_pickup.sections[0].title',
        description: 'returns.faq.local_pickup.sections[0].description',
      },
      {
        title: 'returns.faq.local_pickup.sections[1].title',
        description: 'returns.faq.local_pickup.sections[1].description',
      },
      {
        title: 'returns.faq.local_pickup.sections[2].title',
        description: 'returns.faq.local_pickup.sections[2].description',
      },
      {
        title: 'returns.faq.local_pickup.sections[3].title',
        description: 'returns.faq.local_pickup.sections[3].description',
      },
      {
        title: 'returns.faq.local_pickup.sections[4].title',
        description: 'returns.faq.local_pickup.sections[4].description',
      },
      {
        title: 'returns.faq.local_pickup.sections[5].title',
        description: 'returns.faq.local_pickup.sections[5].description',
      },
      {
        title: 'returns.faq.local_pickup.sections[6].title',
        description: 'returns.faq.local_pickup.sections[6].description',
      },
      {
        title: 'returns.faq.local_pickup.sections[7].title',
        description: 'returns.faq.local_pickup.sections[7].description',
      },
    ],
  },
};

export const PICKUP_FORM_FIELD_MAPPINGS = {
  name: {
    type: 'text',
    placeholder: 'Full Name',
    key: 'customer_name',
    languageKey: 'address_form.input.customer_name',
  },
  firstName: {
    type: 'text',
    placeholder: 'First Name',
    key: 'first_name',
    languageKey: 'address_form.input.first_name',
  },
  lastName: {
    type: 'text',
    placeholder: 'Last Name',
    key: 'last_name',
    languageKey: 'address_form.input.last_name',
  },
  company: {
    type: 'text',
    placeholder: 'Company Name',
    key: 'company_name',
    required: false,
    languageKey: 'address_form.input.company_name',
  },
  address1: {
    type: 'text',
    placeholder: 'Street Address',
    key: 'address_line1',
    languageKey: 'address_form.input.address_line1',
  },
  address2: {
    type: 'text',
    placeholder: 'Address Line 2',
    key: 'address_line2',
    required: false,
    languageKey: 'address_form.input.address_line2',
  },
  postalCode: {
    type: 'text',
    placeholder: 'Postal Code',
    key: 'postal_code',
    languageKey: 'address_form.input.postal_code',
  },
  city: {
    type: 'text',
    placeholder: 'City',
    key: 'city',
    languageKey: 'address_form.input.city',
  },
  state: {
    type: 'select',
    placeholder: 'State',
    key: 'province',
    languageKey: 'address_form.input.province',
  },
  region: {
    type: 'select',
    placeholder: 'Province',
    key: 'province',
    languageKey: 'address_form.input.province',
  },
  country: {
    type: 'select',
    placeholder: 'Country',
    key: 'country',
    languageKey: 'address_form.input.country',
  },
};

export const DEFAULT_MAX_COMMENTS_COUNT = 300;
